import React from 'react';
import PropTypes from 'prop-types';

import SweetSpotItem from './SweetSpotItem';

import sAction from 'sAction';

const SweetSpotResultContainer = (props) => {
    const items = props.data;
    const title = props.title;
    const results = [];
    items.forEach((item, ind) => {
        let itemClass = '';
        if (ind === props.arrowIndex) {
            itemClass += ' arrowSelect';
        }
        results.push(<SweetSpotItem pomClass={itemClass} key={ind} data={item} />);
    });
    return (
        <div className="SweetSpotResultContainer">
            <div className="SweetSpotResultTitle">
                {sAction.translate('LBL_SWEETSPOT_' + title.toUpperCase())}
            </div>
            <div className="SweetSpotResultItemsContainer">
                {results}
            </div>
        </div>
    );
};

SweetSpotResultContainer.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array,
    arrowIndex: PropTypes.number,
};

export default SweetSpotResultContainer;
